

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class DateTimePicker extends Vue {
  @Prop() protected datePickerProps: { [propName: string]: any };
  @Prop() protected timePickerProps: { [propName: string]: any };
  @Prop() protected onDateInput: () => void;
  @Prop() protected onTimeInput: () => void;
  @Prop() protected onNowClicked: () => void;

  get datePickerPropsObj() {
    return Object.assign(
      {
        format: "dd-MM-yyyy",
        clearable: false,
      },
      this.datePickerProps || {}
    );
  }

  get timePickerPropsObj() {
    return Object.assign(
      {
        clearable: false,
        "picker-options": {
          start: "00:00",
          step: "00:15",
          end: "23:45",
        },
      },
      this.timePickerProps || {}
    );
  }
}
